<template>
  <v-app class="fill-height">
    <v-container class="fill-height">
      <v-row align-content="center" flex justify="center">
        <v-col class="text-center">
          You have been logged out or you do not have permissions.
        </v-col>
      </v-row>
    </v-container>
  </v-app>

</template>

<script>
export default {
  name: "LoggedOutView"
}
</script>

<style scoped>

</style>